<template>
  <div class="pc-list" ref="list">
    <DesignerSearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteDesignerInit">删除</button>
          <span></span>
          <button @click="addDesigner">添加</button>
          <!-- <span></span>
          <button @click="exportDesigner">导出数据</button> -->
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="designerList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="designerList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
            <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        sortable="custom"
        width="100"
      ></el-table-column>
      <el-table-column prop="image" label="头像" width="150" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img
              v-if="scope.row.profile_image"
              :src="scope.row.profile_image"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="姓名"
        sortable="custom"
        width="180"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="职位" width="260">
        <template slot-scope="scope">
          <div v-if="scope.row.title">
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="200">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            修改
          </button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="designerDialog"
      :title="DesignerDetail.chinese_name"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="图片">
          <UploadImage
            :img="DesignerDetail.profile_image"
            :width="200"
            :height="160"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="DesignerDetail.title" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="中文名">
          <el-input
            v-model="DesignerDetail.chinese_name"
            placeholder="请输入中文名"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="英文名">
          <el-input
            v-model="DesignerDetail.english_name"
            placeholder="请输入英文名"
          ></el-input>
        </el-form-item>
                <el-form-item label="组织">
          <el-input
            v-model="DesignerDetail.organization"
            placeholder="请输入组织"
          ></el-input>
        </el-form-item>
        <el-form-item label="中文简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="DesignerDetail.chinese_introduce"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="DesignerDetail.english_introduce"
          ></el-input>
        </el-form-item>
        <el-switch
          v-model="DesignerDetail.status"
          active-color="#91CC75"
          inactive-color="#C7C7C7"
          :active-value="1"
          :inactive-value="0"
          style="margin-left: 40px"
        >
        </el-switch>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(DesignerDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="designerList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <!-- @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage" -->
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import DesignerSearch from "./DesignerSearch";
import DeleteHint from "@/components/template/DeleteHint";
import UploadImage from "../../../componentSet/uploadImage.vue";
import {
  getDesignerList_Api,
  updateDesignerDetail_Api,
  deleteDesignerList_Api,
  getDesignerDetail_Api,
  setDesignerDetail_Api,
  //   outputDesigner_Api
} from "@/apis/exhibition.api";
export default {
  components: {
    UploadImage,
    DesignerSearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      DesignerDetail: {
        profile_image: "",
        designer_id: null,
        status:0,
      },
      isSelectAll: false,
      designerList: [],
      checked: [],
    };
  },
  mounted() {
    this.getDesignerListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getDesignerListByRules(data) {
      this.loading = true;
      getDesignerList_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.designerList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.checked = [];
        this.designerList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.designerList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getDesignerListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      this.isUpdateShow = true;
      getDesignerDetail_Api(item.id).then((res) => {
        this.DesignerDetail = res.data;
        this.DesignerDetail.designer_id = this.DesignerDetail.id;
        // this.DesignerDetail.magazine_article_id = res.data.id;
        // if (this.DesignerDetail.author) {
        //   this.DesignerDetail.author = this.DesignerDetail.author.split(",");
        // } else {
        //   this.DesignerDetail.author = [];
        // }
        console.log(res);
      });
    },

    // 修改状态
    changeState(row) {
      updateDesignerDetail_Api({ designer_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getDesignerListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.name_keyword) {
        data.name_keyword = formData.name_keyword;
      }
      if (formData.title_keyword) {
        data.title_keyword = formData.title_keyword;
      }
      return data;
    },
    isDelete() {
      let delete_ids = { designer_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteDesignerList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getDesignerListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    // 删除设计师
    deleteDesignerInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的设计师！", null);
      }
    },
    // 添加设计师
    addDesigner() {
      this.isUpdateShow = true;
      for (let key in this.DesignerDetail) {
        this.DesignerDetail[key] = null;
      }
        this.DesignerDetail.status = 0;
    },
    getUploadImage(img_url) {
      this.DesignerDetail.profile_image = img_url;
    },
    submitBanner(item) {
      if (this.DesignerDetail.id == null) {
        setDesignerDetail_Api(this.DesignerDetail).then((res) => {
          console.log(res);
          this.getDesignerListByRules();  
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        updateDesignerDetail_Api(this.DesignerDetail).then((res) => {
          this.getDesignerListByRules();
          console.log(res);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },
    // 到出数据
    // exportDesigner() {
    //   if (this.checked.length > 0) {
    //     outputDesigner_Api({designer_id_list: this.checked }).then(
    //       (res) => {
    //         this.$global.downloadFile(res, "designerList");
    //       }
    //     );
    //   } else {
    //     this.$global.error(this, "请先勾选要导出的项目！", null);
    //   }
    // },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getDesignerListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-dialog{
    width: 40% !important
}
  /deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
/deep/ .el-upload__tip{
    margin-top: -10px
}
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/DesignerTable.vue